import { render, staticRenderFns } from "./BonusPaymentTypeCreateOrUpdate.vue?vue&type=template&id=5b139f23&"
import script from "./BonusPaymentTypeCreateOrUpdate.vue?vue&type=script&lang=js&"
export * from "./BonusPaymentTypeCreateOrUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports